<div class="d-flex justify-content-center">
  <div class="col-sm-12 col-md-7 col-lg-6 col-xl-5 login-container">
    <nb-card>
      <!-- reset password -->
      <nb-card-body *ngIf="(routeData$ | async).resetPassword">
        <h2 class="text-center mt-4">{{ "welcome" | translate }}</h2>
        <p class="text-center mb-4">
          {{ "welcome_resetPassword" | translate }}
        </p>
        <form (submit)="resetPassword()" #resetForm="ngForm">
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              nbInput
              fullWidth
              fieldSize="small"
              placeholder="Email"
              #resetEmail="ngModel"
              [(ngModel)]="reset.mail"
              name="username"
              email
              required
            />
            <div *ngIf="resetEmail.invalid && resetEmail.touched">
              {{ "email_invalid" | translate }}
            </div>
          </div>
          <div class="form-group" *ngIf="resetPasswordStep2">
            <label>{{ "reset_code" | translate }}</label>
            <input
              type="text"
              nbInput
              fullWidth
              fieldSize="small"
              placeholder="{{ 'reset_code' | translate }}"
              [(ngModel)]="reset.code"
              name="reset_code"
              required
            />
          </div>
          <div class="form-group" *ngIf="resetPasswordStep2">
            <label>{{ "new_password" | translate }}</label>
            <input
              type="password"
              nbInput
              fullWidth
              fieldSize="small"
              placeholder="{{ 'new_password' | translate }}"
              #resetPW="ngModel"
              [(ngModel)]="reset.new_password"
              name="password"
              appPasswordValidator
            />
            <div *ngIf="resetPW.invalid && resetPW.dirty">
              {{ "password_must" | translate }}
              <ul>
                <li *ngFor="let error of resetPW.errors | keyvalue">
                  {{ error.key | translate }}
                </li>
              </ul>
            </div>
          </div>
          <div class="form-group">
            <button
              *ngIf="resetPasswordStep2"
              [disabled]="resetForm.invalid"
              type="submit"
              nbButton
              fullWidth
              status="primary"
            >
              {{ "reset_set_password" | translate }}
            </button>
            <button
              *ngIf="!resetPasswordStep2"
              [disabled]="resetForm.invalid"
              type="submit"
              nbButton
              fullWidth
              status="primary"
            >
              {{ "reset_get_code" | translate }}
            </button>
          </div>
        </form>
      </nb-card-body>

      <!-- sign in -->
      <nb-card-body *ngIf="!(routeData$ | async).resetPassword">
        <nb-tabset fullWidth>
          <nb-tab tabTitle="{{ 'signIn' | translate }}">
            <h2 class="text-center mt-4">{{ "welcome" | translate }}</h2>
            <p class="text-center mb-4">{{ "welcome_login" | translate }}</p>
            <form (submit)="signIn()">
              <div class="form-group">
                <label>Email</label>
                <input
                  type="text"
                  nbInput
                  fullWidth
                  fieldSize="small"
                  placeholder="Email"
                  [(ngModel)]="login.mail"
                  name="username"
                  autocomplete="on"
                />
              </div>
              <div class="form-group">
                <label>{{ "password" | translate }}</label>
                <input
                  type="password"
                  nbInput
                  fullWidth
                  fieldSize="small"
                  placeholder="{{ 'password' | translate }}"
                  [(ngModel)]="login.password"
                  name="password"
                  autocomplete="on"
                />
              </div>
              <div class="form-group d-flex justify-content-center">
                <a [routerLink]="'resetPassword'">{{
                  "forgot_password" | translate
                }}</a>
              </div>
              <div class="form-group">
                <button type="submit" nbButton fullWidth status="primary">
                  {{ "signIn" | translate }}
                </button>
              </div>
            </form>
          </nb-tab>

          <!-- sign up-->
          <nb-tab tabTitle="{{ 'register' | translate }}">
            <h2 class="text-center mt-4">{{ "welcome" | translate }}</h2>
            <p class="text-center mb-4">{{ "welcome_register" | translate }}</p>
            <form
              (submit)="registerStep2 ? confirmSignUp() : signUp()"
              #signupForm="ngForm"
            >
              <!-- Step1 Register -->
              <ng-container *ngIf="!registerStep2">
                <div class="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    nbInput
                    fullWidth
                    fieldSize="small"
                    placeholder="Email"
                    #regEmail="ngModel"
                    [(ngModel)]="register.mail"
                    name="mail"
                    autocomplete="off"
                    email
                    required
                  />
                  <div *ngIf="regEmail.invalid && regEmail.touched">
                    {{ "email_invalid" | translate }}
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ "password" | translate }}</label>
                  <input
                    type="password"
                    nbInput
                    fullWidth
                    fieldSize="small"
                    placeholder="{{ 'password' | translate }}"
                    #regPW="ngModel"
                    [(ngModel)]="register.password"
                    name="password"
                    autocomplete="off"
                    [status]="
                      regPW.invalid && regPW.touched ? 'danger' : 'basic'
                    "
                    appPasswordValidator
                  />
                  <div *ngIf="regPW.invalid && regPW.dirty">
                    {{ "password_must" | translate }}
                    <ul>
                      <li *ngFor="let error of regPW.errors | keyvalue">
                        {{ error.key | translate }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="form-group">
                  <nb-checkbox [(ngModel)]="register.consent" name="consent">
                    {{ "privacy_accept" | translate }}
                    <a href="https://ethinking.de/privacy" target="_blank">{{
                      "privacy_policy" | translate
                    }}</a>
                  </nb-checkbox>
                </div>
                <div class="form-group">
                  <nb-checkbox
                    [(ngModel)]="register.newsletter"
                    name="newsletter"
                  >
                    {{ "signUp_nl" | translate }}
                  </nb-checkbox>
                </div>
              </ng-container>

              <!-- Step 2 Confirm -->
              <ng-container *ngIf="registerStep2">
                <div class="form-group">
                  <label>Email</label>
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    fieldSize="small"
                    placeholder="Email"
                    [(ngModel)]="register.mail"
                    name="mail"
                    autocomplete="off"
                  />
                </div>
                <div class="form-group">
                  <label>{{ "verification_code" | translate }}</label>
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    fieldSize="small"
                    placeholder="{{ 'verification_code' | translate }}"
                    [(ngModel)]="register.confirmationCode"
                    name="code from email"
                    autocomplete="off"
                    required
                  />
                </div>
              </ng-container>

              <!-- submit -->
              <div class="form-group">
                <button
                  *ngIf="!registerStep2"
                  nbButton
                  fullWidth
                  status="primary"
                  [disabled]="signupForm.invalid || !register.consent"
                >
                  {{ "register" | translate }}
                </button>
                <button
                  *ngIf="registerStep2"
                  nbButton
                  fullWidth
                  status="primary"
                >
                  {{ "verify_email" | translate }}
                </button>
              </div>
            </form>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </div>
</div>
